module.exports = __webpack_public_path__ + "fb639409b3afbba4f2dd70a9963b0c60.jpg";